export default "__VITE_ASSET__BGemtRVF__"